
import { Component, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

// Import service
import { UserService } from '../../user/services/user.service';
// Import lib
import { encryptString } from '../../../lib/cryptoJs'

import { orderCSV, orderPDF, orderXLS } from './downloader';
import * as moment from 'moment';
import isEmpty from '../../../lib/validte';
import { PeriodicElement, Sorting } from '../../admin-wallet/models/adminwallet.model';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-deposite-fiat-commision',
  templateUrl: './deposite-fiat-commision.component.html',
  styleUrls: ['./deposite-fiat-commision.component.scss']
})
export class DepositeFiatCommisionComponent {
  isEmpty = isEmpty

  dataSource: MatTableDataSource<PeriodicElement> = new MatTableDataSource()
  displayedColumns: string[] = ['createdAt', 'userCode', 'phoneNo', 'name' ,'transactionId', 'coinCurrentPrice', 'coinValue', 'reward', 'totalCoinvalue', 'fiatAmount', 'approvedBy', 'adminActionDate', 'status', 'action','withdrawRequestDate','withdrawStatus','withdrawApproveDate'];
  isLoading: boolean = false;

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50, 100];

  sorting: Sorting = {};

  statusOptions: string[] = ['all', 'new', 'approved', 'pending', 'rejected'];
  selectedStatus: string = 'all';

  queryParamss: any = {
    page: this.currentPage + 1,
    limit: this.pageSize,

  };


  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  token: string;
  totaldocs: any
  constructor(
    private service: UserService,
    private router: Router,
    private toastr: ToastrService,
    private cookieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.token = this.cookieService.get('admin_token')
  }

  getData(): void {
    this.isLoading = true
    this.service.fiatDepositecommission(this.queryParamss).subscribe({
      next: (v: any) => {

        const orderData = v.data.docs;
        this.totaldocs = v.data.totalDocs
        // this.dataSource = v.result.data
        const kycPromises = orderData.map((trade: any) => {

          if(trade.userId){
            this.service.getSingleKyc(trade.userId).subscribe({
              next:(v:any)=>{
                // Add the salesUserPanNumber to the current trade object
                trade.name = v.result.userId.firstName +" " +v.result.userId.lastName;
              },
              error:(err)=>{
                console.log("the data is " , err);

              }
            })
          }
        } );


        Promise.all(kycPromises).then(() => {


          // All KYC requests have been resolved, update the dataSource
          this.dataSource = new MatTableDataSource(orderData);
          // Set pagination details
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = v.data.totalDocs;
          });

          this.isLoading = false;
        });

      },
      error: (err: any) => {
        this.isLoading = false

        const erros = err.error.errors
        if (!isEmpty(erros))
          this.toastr.error(erros.date)
      }
    });
  }

  onInputChange(event: Event, data: any) {
    const filterValue = (event.target as HTMLInputElement).value;

    // console.log(specialChars.test(filterValue), 'filterValue')
    //  this.queryParamss.phoneNo = filterValue
    if (data === 'userCode') {
      if (filterValue) {
        this.queryParamss.userCode = filterValue; // Add or update `userCode`
      } else {
        delete this.queryParamss.userCode; // Remove `userCode` if input is cleared
      }



    }
    if (data === 'phoneNo') {
      if (filterValue) {
        this.queryParamss.phoneNo = filterValue; // Add or update `userCode`
      } else {
        delete this.queryParamss.phoneNo; // Remove `userCode` if input is cleared
      }



    }

    this.getData()
  }

  onDateChange(event: any, column: string) {
    const selectedDate: any = moment(event.value).format('YYYY-MM-DD');
    //  const selectedDate: any = moment(event.value).format('DD-MM-YYYY');
    //  this.updateFilter(column, selectedDate);

    this.queryParamss.startDate = selectedDate

    this.getData()
  }





  onOptionChange(event: any, column: string) {
    const filterValue = (event.source as HTMLSelectElement).value;
    //   this.updateFilter(column, filterValue);
  }




  pageChanged(event: PageEvent) {
    this.queryParamss.page = event.pageIndex + 1;
    this.queryParamss.limit = event.pageSize;
    this.getData()

    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

  sortData(column: string) {
    if (this.sorting.column === column) {
      if (this.sorting.direction === 1) {
        this.sorting.direction = -this.sorting.direction;
      } else if (this.sorting.direction === -1) {
        this.sorting = {};
      }
    } else {
      this.sorting.column = column;
      this.sorting.direction = 1;
    }
    let sortObj = {};
    if (this.sorting.column) {
      sortObj = { [column]: this.sorting.direction };
    }
    this.queryParamss.sortObj = JSON.stringify(sortObj)
    this.getData()
  }





  redirectToEdit(id: string) {
    this.router.navigateByUrl('/emailtemplates/edit/' + encryptString(id, true))
  }

  handleDoc(value: any): void {
    let docType = {
      page: this.queryParamss.page,
      limit: this.totaldocs,

    }
    this.service.fiatDepositecommission(docType).subscribe(
      (response: any) => {
        if (value === "pdf") {
          const pdfData = JSON.parse(response)
          orderPDF(pdfData.result.pdfData);
        } else if (value === "csv") {
          orderCSV(response);
        } else if (value === 'xls') {

          const wantedFields = ["coin", "phoneNo", "fiatAmount", "transactionId", "userCode", "status", "bankPaymentType", "coinCurrentPrice", "coinValue", "reward", "totalCoinvalue", "createdAt", "description", "approvedBy", "adminActionDate"];
          orderXLS(response.data.docs, wantedFields)
        }
      }
    )
  }



  navigateViewPage(id: string) {
    id = encryptString(id, true)
    this.router.navigateByUrl(`user/kyc/${id}`)
  }

  redirecttodetails(str: string) {
    const decryptString = encryptString(str, true)
    // if (paymentType === 'coin_withdraw') {
    //   return this.router.navigateByUrl('/transfer/coin-withdraw/' + decryptString)
    // }
    this.router.navigateByUrl('/commision-details/' + decryptString)
  }
  navigateApporveWithdraw(str: string) {
    const decryptString = encryptString(str, true)
    this.router.navigateByUrl('/withdraw-stake-details/' + decryptString)
  }
  isEligibleForAction(adminactionDate: string | Date): boolean {
    if (!adminactionDate) return false;

    const actionDate = new Date(adminactionDate);
    const currentDate = new Date();
    const differenceInDays = (currentDate.getTime() - actionDate.getTime()) / (1000 * 60 * 60 * 24);

    return differenceInDays >= 365;
  }
}



